import { readdir, stat, Stats } from 'fs';
import { resolve } from 'path';
import { Common } from '../common';

export class CodeFilePaths {
    private static files: string[];

    /**
     * Retrieves all code files from current repository.
     * @returns {Promise<string[]>} Promise of array containing file paths
     */
    public static async initialize(): Promise<string[]> {
        if (!CodeFilePaths.files) {
            CodeFilePaths.files = await CodeFilePaths.searchFolder(Common.rootPath + '\\src\\app');
        }

        return new Promise(resolvePromise => resolvePromise(CodeFilePaths.files));
    }

    private static async searchFolder(folderPath: string): Promise<string[]> {
        const subDirectories: string[] = await new Promise((resolvePromise, reject) =>
            readdir(folderPath, null, (err, fileResults) => err ? reject(err) : resolvePromise(fileResults))
        );

        const files = await Promise.all(subDirectories.map(async (subDirectory) => {
            const resource = resolve(folderPath, subDirectory);

            const fileStatus: Stats = await new Promise((resolvePromise, reject) =>
                stat(resource, (err, status) => err ? reject(err) : resolvePromise(status))
            );

            return fileStatus.isDirectory() ? this.searchFolder(resource) : resource;
        }));

        return Array.prototype.concat(...files);
    }
}
